import { ITranslate } from "@/interfaces/ITranslate";

export const questionTranslate: ITranslate = {
  title: "título",
  subtitle: "subtítulo",
  answerType: "tipo de respuesta",
};
